<template>
  <div>
    <v-dialog v-model="isOpen" width="500" persistent>
      <v-card>
        <div class="modal-body">
          <v-btn icon @click="onClose" class="modal-close-icon">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-card-title
            class="headline white modal-title green--text"
            primary-title
          >
            {{ title }}
          </v-card-title>
        </div>
        <div class="grey lighten-3 pa-4 mx-4 mb-4 text-xs-left rounded">
          <p class="font-weight-medium">Transfer to</p>

          <div class="my-3">
            <v-layout row wrap>
              <v-flex xs6>
                <div class="col-6 grey--text">Account Holder Name</div>
              </v-flex>
              <v-flex xs6>
                <div class="col-6 green--text">
                  {{ summary.va_account_holder_name }}
                </div>
              </v-flex>
            </v-layout>
          </div>

          <div class="my-3">
            <v-layout row wrap>
              <v-flex xs6>
                <div class="col-6 grey--text">Virtual Account Number</div>
              </v-flex>
              <v-flex xs6>
                <div class="col-6 green--text">
                  {{ summary.va_no }}
                </div>
              </v-flex>
            </v-layout>
          </div>

          <div class="my-3">
            <v-layout row wrap>
              <v-flex xs6>
                <div class="col-6 grey--text">Bank</div>
              </v-flex>
              <v-flex xs6>
                <div class="col-6 green--text">
                  {{ summary.payment_method_name }}
                </div>
              </v-flex>
            </v-layout>
          </div>
        </div>

        <div class="grey lighten-3 pa-4 mx-4 mb-4 text-xs-left rounded">
          <v-expansion-panel>
            <v-expansion-panel-content
              class="m-1"
              v-for="item in summary.payment_instructions"
              :key="item.id"
            >
              <template v-slot:header>
                <div>{{ item.title }}</div>
              </template>
              <v-card>
                <v-card-text>
                  <div v-html="item.description" />
                </v-card-text>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </div>

        <div class="grey lighten-3 pa-4 mx-4 mb-4 text-xs-left rounded">
          <p class="font-weight-medium mb-0">Please make payment before :</p>
          <p id="countdown-date" class="green--text font-weight-bold subheader">
            {{ summary.formatted_va_expired_at }} WIB
          </p>

          <v-chip
            color="green"
            text-color="white"
            class="font-weight-bold caption"
          >
            <p class="mb-0">Time Remaining :</p>
            <p
              class="ml-1 mb-0 subheader pa-1"
              :id="`expiredDateTime_${summary.id_distributor_balance_order}`"
            >
              <Countdown
                v-if="summary"
                :year="summary.yearCountdown"
                :month="summary.monthCountdown"
                :date="summary.dateCountdown"
                :hour="summary.hourCountdown"
                :minute="summary.minuteCountdown"
                :second="summary.secondCountdown"
                :milisecond="summary.milisecondCountdown"
              />
            </p>
          </v-chip>
        </div>

        <div class="grey lighten-3 pa-4 mx-4 mb-4 text-xs-left rounded">
          <p class="font-weight-medium mb-0">Total Amount</p>
          <p id="countdown-date" class="green--text font-weight-bold headline">
            {{ summary.va_gross_amount }}
          </p>
        </div>

        <v-divider></v-divider>

        <v-card-actions class="pa-4 green base d-flex">
          <v-btn
            class="grey lighten-4 green--text text-none mx-5"
            round
            @click="onCheck"
          >
            I have Completed Payment
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import Countdown from '@/components/Countdown.vue'

export default {
  name: 'DetailsTopUpModal',
  components: { Countdown },
  data () {
    return {}
  },
  props: {
    isOpen: {
      type: Boolean,
      default: false
    },
    onClose: {
      type: Function,
      default: () => {}
    },
    title: {
      type: String,
      default: 'Modal Title'
    },
    summary: {
      type: Object,
      default: () => {}
    },
    onNext: {
      type: Function,
      default: () => {}
    }
  },
  computed: {},
  methods: {
    onCheck () {
      this.onNext(this.summary.id_distributor_balance_order)
      this.onClose()
    }
  }
}
</script>
<style scoped>
.modal-body {
  padding: 2em;
  text-align: left;
}

.modal-close-icon {
  float: right;
}

.modal-title {
  font-weight: 600;
  font-size: 1.5em !important;
}

.v-card__title {
  padding: 0;
  margin-bottom: 0;
  margin-top: 2em;
}
</style>
